import { configureStore } from '@reduxjs/toolkit';
import { createPromise } from 'redux-promise-middleware';
import { createBrowserHistory } from 'history';
import rootReducer from '../reducers';
import types from '../actions/types';

export const history = createBrowserHistory();

const promiseMiddleWare = createPromise({
  promiseTypeSuffixes: types
});

export const store = configureStore({
  reducer: rootReducer(history),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  }).concat(promiseMiddleWare)
});
